import React, { useEffect, JSX } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
import MDBox from "components/MDBox"
import { useMaterialUIController, setLayout } from "context"

interface Props {
  children: React.ReactNode
}

export default function DashboardLayout({ children }: Props): JSX.Element {
  const [controller, dispatch] = useMaterialUIController()
  const { miniSidenav } = controller
  const { pathname } = useLocation()

  useEffect(() => {
    setLayout(dispatch, "dashboard")
  }, [pathname, dispatch])

  return (
    <MDBox
      sx={({
        breakpoints,
        transitions,
        functions: { pxToRem }
      }: {
        breakpoints: any
        transitions: any
        functions: { pxToRem: any }
      }) => ({
        p: 3,
        position: "relative",

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard
          })
        }
      })}
    >
      {children}
    </MDBox>
  )
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired
}
